<template>
  <div>
    <el-row :gutter="20">
      <div style="padding: 0px 12px;">
        <h2 style="text-transform:uppercase;letter-spacing: 2px;margin-bottom: 4px;font-size: 24px">Institutions</h2>
        <div style="border-bottom:1px solid rgb(218,219,222);margin-bottom: 4px" />
      </div>
      <el-col :span="10" style="margin-bottom:20px;">
        <el-card class="link-card" shadow="always">
          <div class="link-card-container">
            <div>
              <h2 style="font-size: 18px">EvoCom</h2>
              <p style="height:130px;padding-top:15px">复旦大学进化生物学中心 Center for Evolutionary Biology</p>
              <el-link type="primary" :href="'https://evocom.fudan.edu.cn'">Link</el-link>
            </div>
            <img class="qr-code-img" src="@/assets/img/qrcode/evocomWeChat.jpg">
            <img class="qr-code-img" src="@/assets/img/qrcode/evocom.png">
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-bottom:20px;">
        <el-card class="link-card" shadow="always">
          <div class="link-card-container">
            <div>
              <h2 style="font-size: 18px">HumPOG</h2>
              <p style="height:130px;padding-top:15px">Human Population Omics Group at Fudan University, current group
                website.</p>
              <el-link type="primary" :href="'https://pog.fudan.edu.cn'">Link</el-link>
            </div>
            <img class="qr-code-img" src="@/assets/img/qrcode/HumPOG.png">
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-bottom:20px;">
        <el-card class="link-card" shadow="always">
          <div class="link-card-container">
            <div>
              <h2 style="font-size: 18px">PGG</h2>
              <p style="height:130px;padding-top:15px">Population Genomics Group at PICB, former group website.</p>
              <el-link type="primary" :href="'https://www.picb.ac.cn/PGG/'">Link</el-link>
            </div>
            <img class="qr-code-img" src="@/assets/img/qrcode/PGG.png">
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div v-for="ct in cts" :key="ct">
      <el-row :gutter="20">
        <div style="padding: 0px 12px;">
          <h2 style="text-transform:uppercase;letter-spacing: 2px;margin-bottom: 4px;font-size: 24px">{{ ct }}</h2>
          <div style="border-bottom:1px solid rgb(218,219,222);margin-bottom: 4px" />
        </div>
        <el-col v-for="item in relatedLinks[ct]" :key="item.name" :span="8" style="margin-bottom:20px;">
          <template v-if="item.ct===ct">
            <el-card class="link-card" shadow="always">
              <div class="link-card-container">
                <div>
                  <h2 style="font-size: 18px">{{ item.name }}</h2>
                  <p style="height:130px;padding-top:15px">{{ item.description }}</p>
                  <el-link type="primary" :href="item.link">Link</el-link>
                </div>
                <img class="qr-code-img" :src="`${item.qrcode}`">
              </div>
            </el-card>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cts: ['Projects', 'Meetings'],
      relatedLinks: {
        'Projects': [
          {
            ct: 'Projects',
            name: 'PGG.PGP',
            link: 'https://pog.fudan.edu.cn/pggpgp',
            qrcode: require('@/assets/img/qrcode/pggpgp.png'),
            description: 'A freely accessible web platform for comprehensive analysis of personal genomes'
          },
          {
            ct: 'Projects',
            name: 'CPC',
            link: 'https://pog.fudan.edu.cn/cpc/',
            qrcode: require('@/assets/img/qrcode/CPC.png'),
            description: 'An effort toward understanding genomic diversity and structural variation of natural populations in China and neighboring countries'
          },
          {
            ct: 'Projects',
            name: 'Han100K',
            link: 'https://pog.fudan.edu.cn/han100k/',
            qrcode: require('@/assets/img/qrcode/Han100K.png'),
            description: 'To facilitate the understanding of the population structure and history of Han Chinese'
          },
          {
            ct: 'Projects',
            name: 'AAGC',
            link: 'https://pog.fudan.edu.cn/AAGC/',
            qrcode: require('@/assets/img/qrcode/AAGC.png'),
            description: 'Asian Admixed Genomes Consortium'
          },
          {
            ct: 'Projects',
            name: 'PGG.MHC',
            link: 'https://pog.fudan.edu.cn/pggmhc/#/home',
            qrcode: require('@/assets/img/qrcode/pggmhc.png'),
            description: 'Toward understanding the diversity of major histocompatibility complexes in human populations'
          },
          {
            ct: 'Projects',
            name: 'PGG.SV',
            link: 'https://www.biosino.org/pggsv/#/home',
            qrcode: require('@/assets/img/qrcode/pggsv.png'),
            description: 'A structural variation (SV) database containing 520,525 SVs from 6,263 genomes worldwide'
          },
          {
            ct: 'Projects',
            name: 'PGG.SNV',
            link: 'https://pog.fudan.edu.cn/pggsnv/',
            qrcode: require('@/assets/img/qrcode/pggsnv.png'),
            description: 'A database for understanding evolutionary and medical implications of human single nucleotide variations in diverse populations'
          },
          {
            ct: 'Projects',
            name: 'PGG.Han',
            link: 'https://www.biosino.org/pgghan/index',
            qrcode: require('@/assets/img/qrcode/pgghan.png'),
            description: 'The Han Chinese genome database and analysis platform'
          },
          {
            ct: 'Projects',
            name: 'PGG.Population',
            link: 'https://pog.fudan.edu.cn/population/',
            qrcode: require('@/assets/img/qrcode/pggpopulation.png'),
            description: 'A database for understanding genomic diversity and genetic ancestry of human populations'
          },
          {
            ct: 'Projects',
            name: 'GitHub Repos',
            link: 'https://github.com/orgs/Shuhua-Group/repositories',
            qrcode: require('@/assets/img/qrcode/GitHub.png'),
            description: 'Group GitHub Repositories containing software and pipeline source code.'
          }
        ],
        // 'Institutions': [
        //   {
        //     ct: 'Institutions',
        //     name: 'EvoCom',
        //     link: 'https://evocom.fudan.edu.cn',
        //     qrcode: require('@/assets/img/qrcode/evocomWeChat.jpg'),
        //     description: '复旦大学进化生物学中心 Center for Evolutionary Biology'
        //   },
        //   {
        //     ct: 'Institutions',
        //     name: 'HumPOG',
        //     link: 'https://pog.fudan.edu.cn',
        //     qrcode: require('@/assets/img/qrcode/HumPOG.png'),
        //     description: 'Human Population Omics Group at Fudan University, current group website.'
        //   },
        //   {
        //     ct: 'Institutions',
        //     name: 'PGG',
        //     link: 'https://www.picb.ac.cn/PGG/',
        //     qrcode: require('@/assets/img/qrcode/PGG.png'),
        //     description: 'Population Genomics Group at PICB, former group website.'
        //   },
        //   // {
        //   //   ct: 'Institutions',
        //   //   name: 'EvoCom WeChat Official Account',
        //   //   link: 'https://evocom.fudan.edu.cn',
        //   //   qrcode: require('@/assets/img/qrcode/evocomWeChat.jpg'),
        //   //   description: 'FDU进化生物学研究公众号 Fudan University Evolutionary Biology Research WeChat Official Account'
        //   // },
        // ],
        'Meetings': [
          {
            ct: 'Meetings',
            name: 'SMBE Shanghai 2023',
            link: 'https://pog.fudan.edu.cn/smbeshanghai2023',
            qrcode: require('@/assets/img/qrcode/SMBE.png'),
            description: 'SMBE\'s  (Society for Molecular Biology and Evolution) 2023 regional meeting in Shanghai'
          },
          {
            ct: 'Meetings',
            name: '2023 XTBG Population Genomics Workshop',
            link: 'https://pog.fudan.edu.cn/xtbg2023/#/home',
            qrcode: require('@/assets/img/qrcode/XTBG.png'),
            description: 'The workshop on population genomics in Xishuangbanna Tropical Botanical Garden (XTBG), CAS'
          }

        ]
      }
    }
  }
}
</script>

<style scoped>
.link-card {
  margin: 10px 0;
  height: 220px;
}

.link-card-container {
  display: flex;
  justify-content: space-between;
}

.qr-code-img {
  width: 160px;
  height: 160px;
}
</style>
